module.exports = __webpack_public_path__ + "static/media/1022358.764615f0.jpg";